
import azure from "../../../assets/microsoft-marketplace.png";
import partner from "../../../assets/microsoft-partner.png";
import aws from "../../../assets/avilable_AWS.png";

function RelationsSection() {
  return (
    <section className="bg-gradient-to-r from-[#4169B1] to-[#1A2841] pt-[60px] pb-[80px]">
      <div className="flex flex-col items-center text-center px-6 sm:px-12 max-w-4xl mx-auto">
        <h3 className="text-white text-[22px] md:text-[32px] font-semibold mb-4"><br/> <br/>
        <div className="flex flex-wrap justify-center gap-6 mt-6">
        <img
            src={partner}
            alt="Microsoft Partner"
            className="h-12 md:h-16 object-contain"
          />
          <img
            src={azure}
            alt="Microsoft Azure Marketplace"
            className="h-12 md:h-16 object-contain"
          />
       <img
            src={aws}
            alt="AWS Marketplace"
            className="h-12 md:h-16 object-contain"
          />
        </div> 
        
        </h3>
        <p className="text-[#F4F5F7] text-[16px] md:text-[20px] mb-6 leading-relaxed">
          <br/>
          <a
            href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps/codeyai.test"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[#F4F5F7] hover:text-white transition-colors"
          >
            Get CodeyAI from the Azure Marketplace!!
          </a>
        </p>
        <p className="text-[#F4F5F7] text-[16px] md:text-[20px] mb-6 leading-relaxed">
          <a
            href="https://aws.amazon.com/marketplace/pp/prodview-4i46p7zgq5ncw"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[#F4F5F7] hover:text-white transition-colors"
          >
            Get CodeyAI from AWS Marketplace!!
          </a>
        </p>


      </div>
    </section>
  );
}

export default RelationsSection;
